import { Checkbox, type CheckboxProps } from '@mui/material';
import { useFormContext } from 'react-hook-form';

const CheckedIcon = () => {
  return (
    <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='3' y='3' width='18' height='18' rx='2' fill='#F4A71C' />
      <g id='Icons/check_small'>
        <path
          id='icon'
          d='M10.5 16.4L6.5 12.4L7.9 11L10.5 13.6L17.1 7L18.5 8.4L10.5 16.4Z'
          fill='#1C1C1C'
        />
      </g>
    </svg>
  );
};

export const TUDFormCheckbox = ({
  name,
  disabled = false
}: {
  name: string;
  disabled?: boolean;
}) => {
  const { register } = useFormContext();
  return (
    <Checkbox
      checkedIcon={<CheckedIcon />}
      {...register(name)}
      disabled={disabled}
    />
  );
};

export const TUDCheckbox = (props: CheckboxProps) => {
  return <Checkbox checkedIcon={<CheckedIcon />} {...props} />;
};
